import { ref } from 'vue';
import { ClinicalService, GeolocationService } from '@/services';

export function useCategories() {
  const categories = ref([]);
  const fetchCategories = async (name) => {
    categories.value = !name ? [] : await ClinicalService.getCategoriesByName(name);
  };

  return [categories, fetchCategories];
}

export function useLocations() {
  const locations = ref([]);
  const fetchLocations = async (name) => {
    locations.value = !name || name.length < 3 ? [] : await GeolocationService.getLocationByName(name);
  };

  return [locations, fetchLocations];
}
